import { createStore, compose, applyMiddleware } from 'redux';
import rootReducer from '../modules';
import thunk from 'redux-thunk';
import * as sagas from '../modules/sagas';
import createSagaMiddleware from 'redux-saga';
//import {persistStore, autoRehydrate} from 'redux-persist';
//import {REHYDRATE} from 'redux-persist/constants';
import createActionBuffer from '../../../tools/redux-action-buffer'; //eslint-disable-line
import createExpirationTransform from '../../../tools/redux-persist-transform-expire'; //eslint-disable-line
//import expireCookie from '../../util/persist/persistCookieTransform';
import _ from 'lodash';

const sagaMiddleware = createSagaMiddleware();
//const expireTransform = createExpirationTransform();

export default function configureStore(initialState) {
  // return createStore(rootReducer, initialState);
  let store = createStore(rootReducer, initialState, compose(
    //autoRehydrate(),
    //applyMiddleware(createActionBuffer(REHYDRATE, ['hg/common/TOGGLE_SPINNER', 'hg/content/SET_CONTENT']), thunk, sagaMiddleware),
    applyMiddleware(thunk, sagaMiddleware),
    )
  );

  //persistStore(store, {transforms: [expireTransform, expireCookie]});

  // run saga watchers
  _.values(sagas).forEach(sagaMiddleware.run);
  return store;
}



/** WEBPACK FOOTER **
 ** ./client/redux/store/configureStore.prod.js
 **/